(function () {
  const Online = window.RB.Online;
  const U = window.UIX;
  const APP = window.APP;
  const el = window.UIDOM.el;
  const esc = window.UIDOM.esc;

  const S = { id: null, names: ["", ""], over: null, down: false, seq: -1, synced: false, match: null };

  function resync() {
    S.synced = false;
    Online.send({ t: "watchGame", gameId: S.id });
  }

  function loadFull(msg) {
    if (RB.Anim) RB.Anim.flush();
    APP.game = { version: Kernel.ENGINE_VERSION, setup: { ai: [false, false] }, log: [] };
    APP.state = msg.state;
    APP.viewIndex = null;
    APP.selection = null;
    APP.menu = null;
    APP.picked = [];
    APP.assign = {};
    APP.moveSel = null;
    APP.error = null;
    APP.seat = msg.seat;
    APP.viewAs = msg.seat;
    APP.ai = [false, false];
    APP.screen = "game";
    S.seq = msg.seq;
    S.names = msg.names || S.names;
    S.over = msg.over || null;
    S.synced = true;
    U.render();
  }

  function applyStep(msg) {
    if (!S.synced) return;
    if (msg.seq <= S.seq) return;
    if (msg.seq !== S.seq + 1) return resync();
    S.seq = msg.seq;
    U.applyRemoteState(msg.action, msg.state, msg.events);
  }

  function overlay() {
    if (!S.over) return null;
    const wrap = el("div", "ovresult");
    const card = el("div", "ovcard");
    const mm = S.match;
    const inMatch = mm && mm.best > 1;
    const won = S.over.winner === APP.seat;
    card.appendChild(el("div", "ovtitle disp", inMatch && !mm.over
      ? (won ? "GAME WON" : "GAME LOST")
      : won ? "VICTORY" : "DEFEAT"));
    const who = S.names[S.over.winner] || ("Player " + (S.over.winner + 1));
    card.appendChild(el("div", "ovwho", esc(who) + " wins" + (S.over.reason === "concede" ? " by concession" : "")));
    if (inMatch) {
      card.appendChild(el("div", "ovwho", esc(RB.Match.label(mm) + " · " +
        (S.names[0] || "Seat 1") + " " + mm.wins[0] + "–" + mm.wins[1] + " " + (S.names[1] || "Seat 2") +
        (mm.over ? " · " + (S.names[mm.over.winner] || "") + " takes the match" : ""))));
    }
    card.appendChild(reviewRow());
    if (inMatch && !mm.over) {
      const next = el("button", "btn primary big", "Game " + mm.gameNo + " — side deck");
      next.title = "Sideboard and present a battlefield for the next game of this match";
      next.onclick = function () { Online.send({ t: "watchGame", gameId: S.id }); };
      card.appendChild(next);
    }
    const back = el("button", inMatch && !mm.over ? "btn" : "btn primary big", inMatch && !mm.over ? "Leave the match" : "Back to lobbies");
    back.onclick = function () { Online.go("/play"); };
    card.appendChild(back);
    wrap.appendChild(card);
    return wrap;
  }

  function loadMatch(msg) {
    S.names = msg.names || S.names;
    S.match = msg.match;
    S.over = null;
    S.synced = false;
    APP.seat = msg.seat;
    APP.error = null;
    U.loadOnlineMatch(msg);
  }

  function sendPrep(choice) {
    Online.send({ t: "prep", bf: choice.bf, deck: choice.deck || null });
  }

  function sendFirst(first) {
    Online.send({ t: "first", first: first === true });
  }

  function postJson(url, body) {
    return fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }

  function reviewRow() {
    const row = el("div", "revbar ovrev");
    const note = el("span", "revnote", "");
    const save = el("button", "btn small", "Save for review");
    save.title = "Ask the server to store this game so the native player can analyse your decisions.";
    save.onclick = function () {
      save.disabled = true;
      note.textContent = "Saving…";
      postJson("/api/trainer/games/online", { gameId: S.id }).then(function (j) {
        if (!j || j.error) throw new Error((j && j.error) || "save failed");
        note.textContent = "Saved as " + j.id + ".";
        const go = el("button", "btn small primary", "Review my play (" + esc(S.names[APP.seat] || "your seat") + ")");
        go.onclick = function () {
          go.disabled = true;
          postJson("/api/trainer/review", { gameId: j.id, seat: APP.seat, strength: "quick" }).then(function (q) {
            if (!q || q.error) throw new Error((q && q.error) || "queue failed");
            location.href = "/trainer#reviews";
          }).catch(function (e) {
            go.disabled = false;
            note.textContent = "Could not queue: " + e.message;
          });
        };
        row.appendChild(go);
      }).catch(function (e) {
        save.disabled = false;
        note.textContent = "Could not save: " + e.message;
      });
    };
    row.appendChild(save);
    row.appendChild(note);
    return row;
  }

  function leave() {
    if (APP.screen !== "match" && APP.screen !== "pregame") Online.send({ t: "concede" });
    setTimeout(function () { Online.go("/play"); }, 120);
  }

  const Adapter = {
    dispatch(action) {
      if (S.over) { APP.error = "This game is over."; U.render(); return; }
      const pd = APP.state && APP.state.pending;
      if (!pd || pd.player !== APP.seat) {
        APP.error = "It is your opponent's decision.";
        U.render();
        return;
      }
      APP.error = null;
      Online.send({ t: "action", action: action });
    },
    leave: leave,
    overlay: overlay,
    inMatch() { return !!S.match && S.match.best > 1; },
    seat() { return APP.seat; },
    opponentName() { return S.names[APP.seat === 0 ? 1 : 0] || "Your opponent"; },
  };

  Online.Game = { sendPrep: sendPrep, sendFirst: sendFirst };

  Online.bootGame = function () {
    S.id = location.pathname.split("/").pop();
    APP.net = Adapter;
    APP.seat = null;
    APP.screen = "game";
    if (RB.Anim) {
      RB.Anim.onIdle = function () {
        if (U.IDLE_RENDER && APP.screen === "game" && APP.game) U.render();
      };
      try {
        const sp = localStorage.getItem("riftbound-anim-speed");
        if (sp !== null && sp !== "") RB.Anim.speed = +sp;
      } catch (e) { }
    }
    try { APP.showLog = localStorage.getItem(U.LOG_KEY) === "1"; } catch (e) { }
    try { APP.logDetail = localStorage.getItem(U.LOG_DETAIL_KEY) !== "0"; } catch (e) { }
    APP.showManual = false;
    try { APP.manualPay = localStorage.getItem(U.MANUAL_PAY_KEY) === "1"; } catch (e) { }
    APP.showReplay = false;

    const root = document.getElementById("app");
    root.innerHTML = "";
    root.appendChild(el("div", "obwait disp", "Joining the game…"));

    Online.Net.onReady = function () {
      S.down = false;
      resync();
    };
    Online.Net.onDown = function () {
      S.down = true;
      S.synced = false;
      if (APP.game) { APP.error = "Connection lost — reconnecting…"; U.render(); }
    };
    Online.Net.onMessage = function (msg) {
      if (msg.t === "game") return loadFull(msg);
      if (msg.t === "match") return loadMatch(msg);
      if (msg.t === "step") return applyStep(msg);
      if (msg.t === "over") {
        S.over = msg.over;
        S.match = msg.match || S.match;
        APP.screen = "game";
        U.render();
        return;
      }
      if (msg.t === "error") {
        APP.error = msg.msg;
        if (!APP.game) {
          const r = document.getElementById("app");
          r.innerHTML = "";
          const box = el("div", "obwait", esc(msg.msg));
          const back = el("button", "btn", "Back to lobbies");
          back.onclick = function () { Online.go("/play"); };
          box.appendChild(back);
          r.appendChild(box);
          return;
        }
        U.render();
        return;
      }
    };
    Online.connect();
  };
})();
